import { makeStyles } from '@material-ui/core';

const sidebarUseStyles = makeStyles(theme => ({
	contentMenuFeed: {
		paddingTop: '0px',
		paddingBottom: '0px',
		'& .MuiListItemText-primary': {
			fontSize: '14px !important',
			color: '#565A5C !important',
			fontFamily: 'Roboto !important',
			'@media(max-width:1024px)': {
				fontSize: '10px !important',
			},
		},
		disableRipple: true,
		'& .MuiList-padding': {
			paddingTop: '0px !important',
			paddingBottom: '0px !important',
		},
		'& .MuiListItemText-root': {
			marginTop: '0px !important',
			marginBottom: '0px !important',
		},
		'& .MuiListItem-button': {
			marginBottom: '6px !important',
			width: '228px',
			height: '40px',
			borderRadius: '4px',
			margin: 'auto',
			border: '2px solid transparent',
			'@media(max-width:1024px)': {
				width: '90%',
				height: '30px',
			},
		},
		'& > * svg': {
			opacity: '1',
			color: '#565A5C !important',
			marginLeft: '2px',
		},
		'& .MuiListItem-root': {
			disableTouchRipple: 'true',
		},
		'& .MuiListItem-button:focus-visible': { border: '2px solid #002855', backgroundColor: '#FFFFFF' },
		'& .MuiListItem-button:hover': {
			'& > * svg': {
				color: '#565a5c',
			},
			width: '228px',
			height: '40px',
			margin: 'auto',
			// border: '2px solid #007DBA',
			backgroundColor: '#cfdbe5 !important',
			'@media(max-width:1024px)': {
				width: '90%',
				height: '30px',
			},
			'& .MuiTypography-body1': {
				color: '#565a5c',
				opacity: '1',
			},
		},
		'& .Mui-selected': {
			backgroundColor: '#CFDBE5 !important',
			marginBottom: '6px !important',
			'& .MuiTypography-body1': {
				color: '#565a5c !important',
			},
			'& .MuiListItemText-primary': {
				fontSize: '14px !important',
				color: '#565a5c !important',
				fontFamily: 'Roboto !important',
				'@media(max-width:1024px)': {
					fontSize: '10px !important',
				},
			},
			'& > * svg': {
				color: '#565a5c !important',
			},
		},
		'& .Mui-selected:hover': {
			backgroundColor: '#565a5c !important',
			'& .MuiListItemText-primary': {
				// fontSize: '14px !important',
				color: '#FFFFFF !important',
				fontFamily: 'Roboto!important',
			},
			'& > * svg': {
				color: '#FFFFFF !important',
			},
		},
	},
	miniContentMenuFeed: {
		paddingTop: '0px',
		paddingBottom: '0px',
		'& .MuiListItemText-primary': {
			fontSize: '14px !important',
			color: '#565A5C !important',
			fontFamily: 'Roboto !important',
		},
		disableRipple: true,
		'& .MuiList-padding': {
			paddingTop: '0px !important',
			paddingBottom: '0px !important',
		},
		'& .MuiListItemText-root': {
			marginTop: '0px !important',
			marginBottom: '0px !important',
		},

		'& .MuiListItem-button': {
			marginBottom: '6px !important',
			width: '42px',
			height: '40px',
			borderRadius: '4px',
		},
		'& > * svg': {
			opacity: '1',
			color: '#565A5C !important',
			height: '18px !important',
			width: '18px !important',
		},
		'& .MuiListItem-root': {
			disableTouchRipple: 'true',
		},

		'& .MuiListItem-button:hover': {
			'& > * svg': {
				color: '#565a5c !important',
			},
			height: '40px',
			backgroundColor: '#F4F8FC !important',
			border: 'none !important',
			'& .MuiTypography-body1': {
				color: '#565a5c !important',
				opacity: '1',
			},
			'@media (max-width:768px)': {
				margin: 'inherit',
			},
		},
		'& .Mui-selected': {
			backgroundColor: '#CFDBE5 !important',
			marginBottom: '6px !important',

			'& .MuiTypography-body1': {
				color: '#565a5c !important',
			},
			'& .MuiListItemText-primary': {
				fontSize: '14px !important',
				color: '#565a5c !important',
				fontFamily: 'Roboto !important',
			},
			'& > * svg': {
				color: '#565a5c !important',
			},
		},
		'& .Mui-selected:hover': {
			backgroundColor: '#CFDBE5 !important',
			'& .MuiListItemText-primary': {
				fontSize: '14px !important',
				color: '#565a5c !important',
				fontFamily: 'Roboto!important',
			},
			'& > * svg': {
				color: '#565a5c !important',
			},
		},
	},
}));

export default sidebarUseStyles;
